var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opacity),expression:"opacity"}],staticClass:"detail-header",style:({opacity:_vm.opacity})},[_c('base-icon',{staticClass:"detail-header-icon",attrs:{"icon-text":"icon-4"},nativeOn:{"click":function($event){_vm.$router.go(-1)}}}),_vm._v("\n  景点详情\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fcc3a52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/detail/components/Header.vue
// module id = null
// module chunks = 